/* eslint-disable jsx-a11y/alt-text */
import  * as React from "react";
import { observer } from "mobx-react";
import { UnitButton } from "./../../MultiShotControl/UnitButton/UnitButton";
import { IUnitButtonParams } from "./../../MultiShotControl/UnitButton/IUnitButtonParams";
import { IParameterSettingsPanelParams } from "./IParameterSettingsPanelParams";
import { ChangeDataPopUpFromPanel } from "./../ChangeDataPopUpFromPanel/ChangeDataPopUpFromPanel";

export interface IParameterSettingsPanelState {
    showChangeData: boolean;
}

@observer
export class ParameterSettingsPanel extends React.Component<IParameterSettingsPanelParams, IParameterSettingsPanelState>{
    constructor(props: IParameterSettingsPanelParams) {
        super(props, undefined);
        this.state = { showChangeData: false };
    }

    changeDataOptions() {
        this.setState({ showChangeData: !this.state.showChangeData });
    }

    render() {
        return <div className="ParameterSettingsPanel">
            <div className="player-name-and-ball">
                <div className="ball-icon above-row" style={{ backgroundColor: this.props.color }}>
                    <img src="Images/MultiShotControl/single-shot-icon-without-border.png" alt="Ball icon" />
                </div>
                <div className="player-name">
                    <span>{this.props.playerName}</span>
                </div>
            </div>
            {this.props.showChangeDataAndUnitsButtons &&
                <div className="change-data-and-change-units">
                    <div className="change-data hidden-print" onClick={() => { this.changeDataOptions(); }}>
                        <span>Change Data</span><img className="change-data-icon" src="Images/MultiShotControl/change-data-icon.svg" />
                    </div>
                    <UnitButton {...this.getUnitButtonParams() } />
                </div>
            }
            {this.state.showChangeData &&
                <ChangeDataPopUpFromPanel measurementParameters={this.props.measurementParameters} color={this.props.color} changeDataOptions={this.changeDataOptions.bind(this)} disableTile={this.props.disableTile} reportStore= {this.props.reportStore}></ChangeDataPopUpFromPanel>
            }
        </div>
    }
    private getUnitButtonParams() {
        const result: IUnitButtonParams = {
            unitSystem: this.props.unitPresentation.unitSystem,
            changeUnit: this.props.changeUnit
        };
        return result;
    }
}
